import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MuiPaper from 'material-ui/Paper';
import MuiFlatButton from 'material-ui/FlatButton';
import MuiDialog from 'material-ui/Dialog';
import MuiClose from 'material-ui/svg-icons/navigation/close';
import { manualActivationCompleted } from '../../store/ducks/connected-product';
import { openForum } from '../../store/ducks/shared';
import styles from './styles';
import './index.css';

export class PureManualActivation extends Component {
  static propTypes = {
    handleDone: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node)]),
    openForum: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);
    this.state = { contactModalOpen: false, pageIndex: 0 };
  }

  handleOpenModal = () => {
    this.setState({ contactModalOpen: true });
  }

  handleCloseModal = () => {
    this.setState({ contactModalOpen: false });
  }

  moveBackwards = () => {
    const pageIndex = (this.state.pageIndex <= 0) ? 0 : this.state.pageIndex - 1;
    this.setState({ pageIndex });
  }

  moveForward = () => {
    if (this.state.pageIndex === this.props.children.length - 1) return this.props.handleDone();
    this.setState({ pageIndex: this.state.pageIndex + 1 });
  }

  renderCurrentChild = (child) => {
    return React.cloneElement(child, {
      ref: (el) => {
        if (!el) return;
        el = el.getWrappedInstance ? el.getWrappedInstance() : el;
        this.currentChild = el;
      },
      moveForward: this.moveForward,
      moveBackwards: this.moveBackwards,
    });
  }

  openForum = () => {
    this.props.openForum();
  }

  render() {
    const child = this.props.children[this.state.pageIndex];
    return (
      <div className="manual-activation">
        <div className="activate-step-heading">
          <MuiClose onClick={ this.props.handleDone } />
          <h1>Activate your machine.</h1>
        </div>

        <div className="activate-step-content-wrapper">
          <MuiPaper style={ styles.paperStyle } zDepth={ 3 } className="activate-step-paper">
            { this.renderCurrentChild(child) }
          </MuiPaper>

          <div className={ 'activate-step-progress activate-step-progress-' + this.state.pageIndex }>
            <span className="activate-step-current" />
          </div>
        </div>

        <footer>
          <p>Got questions?<br /><a onClick={ this.handleOpenModal }>Contact our customer service team.</a>
            <MuiDialog
              actions={ [
                <MuiFlatButton
                  key="action-1"
                  className="activate-exit-dialog"
                  label="Exit"
                  labelStyle={ styles.dialogLabelStyle }
                  style={{ width: '100%' }}
                  hoverColor="transparent"
                  rippleColor="transparent"
                  onClick={ this.handleCloseModal }
                />
              ] }
              actionsContainerStyle={ styles.dialogActionsContainerStyle }
              contentStyle={ styles.dialogContentStyle }
              titleStyle={ styles.dialogTitleStyle }
              open={ this.state.contactModalOpen }
              onRequestClose={ this.handleCloseModal }
              title="Having trouble?"
            >
              <p className="activate-step-modal-content">Visit our <a onClick={ this.openForum }>Forum</a> for this issue, or&nbsp;contact&nbsp;Customer Service at <a href="tel:18666081798">1-866-608-1798</a></p>
            </MuiDialog>
          </p>
        </footer>
      </div>
    );
  }
}

const ManualActivation = connect(
  null,
  dispatch => ({
    handleDone: () => dispatch(manualActivationCompleted()),
    openForum: () => dispatch(openForum())
  })
)(PureManualActivation);

export default ManualActivation;
